/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './dental-mouth-item.reducer';

export const DentalMouthItem = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const dentalMouthItemList = useAppSelector(state => state.dentalMouthItem.entities);
  const loading = useAppSelector(state => state.dentalMouthItem.loading);
  const totalItems = useAppSelector(state => state.dentalMouthItem.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="dental-mouth-item-heading" data-cy="DentalMouthItemHeading">
        <Translate contentKey="tinyMedicRestApp.dentalMouthItem.home.title">Dental Mouth Items</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.dentalMouthItem.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/dental-mouth-item/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.dentalMouthItem.home.createLabel">Create new Dental Mouth Item</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.dentalMouthItem.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {dentalMouthItemList && dentalMouthItemList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('available')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.available">Available</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('available')} />
                </th>
                <th className="hand" onClick={sort('implant')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.implant">Implant</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('implant')} />
                </th>
                <th className="hand" onClick={sort('mobility')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.mobility">Mobility</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mobility')} />
                </th>
                <th className="hand" onClick={sort('fork1')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.fork1">Fork 1</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('fork1')} />
                </th>
                <th className="hand" onClick={sort('bleeding1')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.bleeding1">Bleeding 1</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bleeding1')} />
                </th>
                <th className="hand" onClick={sort('bleeding2')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.bleeding2">Bleeding 2</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bleeding2')} />
                </th>
                <th className="hand" onClick={sort('bleeding3')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.bleeding3">Bleeding 3</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bleeding3')} />
                </th>
                <th className="hand" onClick={sort('bleeding4')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.bleeding4">Bleeding 4</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bleeding4')} />
                </th>
                <th className="hand" onClick={sort('bleeding5')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.bleeding5">Bleeding 5</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bleeding5')} />
                </th>
                <th className="hand" onClick={sort('bleeding6')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.bleeding6">Bleeding 6</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bleeding6')} />
                </th>
                <th className="hand" onClick={sort('plaque1')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.plaque1">Plaque 1</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('plaque1')} />
                </th>
                <th className="hand" onClick={sort('plaque2')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.plaque2">Plaque 2</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('plaque2')} />
                </th>
                <th className="hand" onClick={sort('plaque3')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.plaque3">Plaque 3</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('plaque3')} />
                </th>
                <th className="hand" onClick={sort('plaque4')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.plaque4">Plaque 4</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('plaque4')} />
                </th>
                <th className="hand" onClick={sort('plaque5')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.plaque5">Plaque 5</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('plaque5')} />
                </th>
                <th className="hand" onClick={sort('plaque6')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.plaque6">Plaque 6</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('plaque6')} />
                </th>
                <th className="hand" onClick={sort('gum')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.gum">Gum</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('gum')} />
                </th>
                <th className="hand" onClick={sort('margin1')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.margin1">Margin 1</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('margin1')} />
                </th>
                <th className="hand" onClick={sort('margin2')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.margin2">Margin 2</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('margin2')} />
                </th>
                <th className="hand" onClick={sort('margin3')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.margin3">Margin 3</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('margin3')} />
                </th>
                <th className="hand" onClick={sort('margin4')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.margin4">Margin 4</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('margin4')} />
                </th>
                <th className="hand" onClick={sort('margin5')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.margin5">Margin 5</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('margin5')} />
                </th>
                <th className="hand" onClick={sort('margin6')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.margin6">Margin 6</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('margin6')} />
                </th>
                <th className="hand" onClick={sort('depth1')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.depth1">Depth 1</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('depth1')} />
                </th>
                <th className="hand" onClick={sort('depth2')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.depth2">Depth 2</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('depth2')} />
                </th>
                <th className="hand" onClick={sort('depth3')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.depth3">Depth 3</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('depth3')} />
                </th>
                <th className="hand" onClick={sort('depth4')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.depth4">Depth 4</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('depth4')} />
                </th>
                <th className="hand" onClick={sort('depth5')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.depth5">Depth 5</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('depth5')} />
                </th>
                <th className="hand" onClick={sort('depth6')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.depth6">Depth 6</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('depth6')} />
                </th>
                <th className="hand" onClick={sort('fork2')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.fork2">Fork 2</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('fork2')} />
                </th>
                <th className="hand" onClick={sort('fork3')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.fork3">Fork 3</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('fork3')} />
                </th>
                <th className="hand" onClick={sort('notes')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.notes">Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('notes')} />
                </th>
                <th className="hand" onClick={sort('treatments')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.treatments">Treatments</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('treatments')} />
                </th>
                <th className="hand" onClick={sort('examinedDate')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.examinedDate">Examined Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('examinedDate')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.tooth">Tooth</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.medicalHistory">Medical History</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.dentalMouthItem.exam">Exam</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {dentalMouthItemList.map((dentalMouthItem, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/dental-mouth-item/${dentalMouthItem.id}`} color="link" size="sm">
                      {dentalMouthItem.id}
                    </Button>
                  </td>
                  <td>{dentalMouthItem.available ? 'true' : 'false'}</td>
                  <td>{dentalMouthItem.implant ? 'true' : 'false'}</td>
                  <td>{dentalMouthItem.mobility}</td>
                  <td>{dentalMouthItem.fork1}</td>
                  <td>{dentalMouthItem.bleeding1}</td>
                  <td>{dentalMouthItem.bleeding2}</td>
                  <td>{dentalMouthItem.bleeding3}</td>
                  <td>{dentalMouthItem.bleeding4}</td>
                  <td>{dentalMouthItem.bleeding5}</td>
                  <td>{dentalMouthItem.bleeding6}</td>
                  <td>{dentalMouthItem.plaque1}</td>
                  <td>{dentalMouthItem.plaque2}</td>
                  <td>{dentalMouthItem.plaque3}</td>
                  <td>{dentalMouthItem.plaque4}</td>
                  <td>{dentalMouthItem.plaque5}</td>
                  <td>{dentalMouthItem.plaque6}</td>
                  <td>{dentalMouthItem.gum}</td>
                  <td>{dentalMouthItem.margin1}</td>
                  <td>{dentalMouthItem.margin2}</td>
                  <td>{dentalMouthItem.margin3}</td>
                  <td>{dentalMouthItem.margin4}</td>
                  <td>{dentalMouthItem.margin5}</td>
                  <td>{dentalMouthItem.margin6}</td>
                  <td>{dentalMouthItem.depth1}</td>
                  <td>{dentalMouthItem.depth2}</td>
                  <td>{dentalMouthItem.depth3}</td>
                  <td>{dentalMouthItem.depth4}</td>
                  <td>{dentalMouthItem.depth5}</td>
                  <td>{dentalMouthItem.depth6}</td>
                  <td>{dentalMouthItem.fork2}</td>
                  <td>{dentalMouthItem.fork3}</td>
                  <td>{dentalMouthItem.notes}</td>
                  <td>{dentalMouthItem.treatments}</td>
                  <td>{dentalMouthItem.examinedDate}</td>
                  <td>{dentalMouthItem.active ? 'true' : 'false'}</td>
                  <td>{dentalMouthItem.cursor}</td>
                  <td>{dentalMouthItem.lastupdated}</td>
                  <td>{dentalMouthItem.microSec}</td>
                  <td>{dentalMouthItem.timestampentry}</td>
                  <td>
                    {dentalMouthItem.tooth ? <Link to={`/dental-tooth/${dentalMouthItem.tooth.id}`}>{dentalMouthItem.tooth.id}</Link> : ''}
                  </td>
                  <td>
                    {dentalMouthItem.patient ? (
                      <Link to={`/gluco-user/${dentalMouthItem.patient.id}`}>{dentalMouthItem.patient.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {dentalMouthItem.medicalHistory ? (
                      <Link to={`/medical-history/${dentalMouthItem.medicalHistory.id}`}>{dentalMouthItem.medicalHistory.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {dentalMouthItem.exam ? (
                      <Link to={`/dental-exam-and-treatment/${dentalMouthItem.exam.id}`}>{dentalMouthItem.exam.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/dental-mouth-item/${dentalMouthItem.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/dental-mouth-item/${dentalMouthItem.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/dental-mouth-item/${dentalMouthItem.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.home.notFound">No Dental Mouth Items found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={dentalMouthItemList && dentalMouthItemList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default DentalMouthItem;
